import React, { useState } from "react";

import { useTranslation } from "react-i18next";

import ColorPalettesPicker from "../../../../components/ui/color-palettes-picker/ColorPalettesPicker";
import RoundedTabs from "../../../../components/ui/tabs/rounded-tabs/RoundedTabs";
import {
  OverviewContainer,
  OverviewDescription,
  Link,
  OverviewHeader,
  OverviewHeaderContainer,
  OverviewHeading,
  OverviewTemplatesContainer,
  TemplatesHeader,
  TemplatesContainer,
  TemplatesHeading,
} from "./styles";
import { useOpticsStore } from "../../../../stores/use-optics-store";
import {
  OVERVIEW_CATEGORIES,
  OVERVIEW_TABS,
  OVERVIEW_TEMPLATES,
} from "./defaults";

const Overview = () => {
  const [selectedTab, setSelectedTab] = useState("all");
  const { t } = useTranslation();
  const setMacro = useOpticsStore((state) => state.setMacro);

  const filteredTemplates = OVERVIEW_TEMPLATES.filter(
    (template) => selectedTab === "all" || template.category === selectedTab
  );

  const tabs = OVERVIEW_TABS(t);

  const isTeamsAndActivityIncluded =
    selectedTab === OVERVIEW_CATEGORIES.TEAMS_AND_ACTIVITY ||
    selectedTab === "all";

  const teamsAndActivityTemplates = filteredTemplates.filter(
    (template) => template.category === OVERVIEW_CATEGORIES.TEAMS_AND_ACTIVITY
  );

  const otherTemplates = filteredTemplates.filter(
    (template) => template.category !== OVERVIEW_CATEGORIES.TEAMS_AND_ACTIVITY
  );

  return (
    <OverviewContainer>
      <OverviewHeader>
        <OverviewHeaderContainer>
          <OverviewHeading>{t("overview.title")}</OverviewHeading>
          <OverviewDescription>{t("overview.description")}</OverviewDescription>
        </OverviewHeaderContainer>
        <ColorPalettesPicker />
      </OverviewHeader>

      <RoundedTabs
        tabs={tabs}
        selectedTab={selectedTab}
        setSelectedTab={(tab) => setSelectedTab(tab)}
      />

      <OverviewTemplatesContainer>
        {otherTemplates.map(({ macro, title, link, Component }) => (
          <TemplatesHeader key={macro} style={{ rowGap: "16px", flex: 1 }}>
            <TemplatesContainer>
              <TemplatesHeading>
                {t("overview.macros." + title)}
              </TemplatesHeading>
              {link && (
                <Link onClick={() => setMacro({ key: macro })}>
                  {t("overview.macros." + link)}
                </Link>
              )}
            </TemplatesContainer>
            <Component />
          </TemplatesHeader>
        ))}
      </OverviewTemplatesContainer>

      {isTeamsAndActivityIncluded && (
        <OverviewTemplatesContainer isGrid>
          {teamsAndActivityTemplates.map(
            ({ macro, title, link, Component }) => (
              <TemplatesHeader key={macro} style={{ rowGap: "16px", flex: 1 }}>
                <TemplatesContainer>
                  <TemplatesHeading>
                    {t("overview.macros." + title)}
                  </TemplatesHeading>
                  {link && (
                    <Link onClick={() => setMacro({ key: macro })}>
                      {t("overview.macros." + link)}
                    </Link>
                  )}
                </TemplatesContainer>
                <Component />
              </TemplatesHeader>
            )
          )}
        </OverviewTemplatesContainer>
      )}
    </OverviewContainer>
  );
};

export default Overview;
